import { render, staticRenderFns } from "./Generic_Widgets.vue?vue&type=template&id=3a83c499&scoped=true&"
import script from "./Generic_Widgets.vue?vue&type=script&lang=js&"
export * from "./Generic_Widgets.vue?vue&type=script&lang=js&"
import style0 from "./Generic_Widgets.vue?vue&type=style&index=0&id=3a83c499&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a83c499",
  null
  
)

export default component.exports